import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { AdesaoService } from 'src/app/services/adesao.service';
import { FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { UtilService } from "src/app/services/util.service";

declare var $: any;

@Component({
    selector: "app-fim-adesao",
    templateUrl: "./fim-adesao.component.html",
    styleUrls: ["./fim-adesao.component.css"],
    imports: [CommonModule, ReactiveFormsModule, FormsModule]
})
export class FimAdesaoComponent implements OnInit {

  public dataBoleto: string = "";
  public protocolo: string = "";
  forma_pagamento: string ="";
  loading: boolean = false;
  dadosBoleto: any = null;
  dadosPix: any = null;
  dadosCobranca: any = null;
  idcobranca: number;

  modalStep: string = 'aporte_1';
  botaoDesabilitado: boolean = false;
  botaoDesabilitaPix: boolean = false;
  botaoDesabilitaBoleto: boolean = false;
  mostrarBotao: boolean = true;



  @Input() parentForm: FormGroup;
  @Output() ativarBotao = new EventEmitter<boolean>();

  constructor(
    private autenticacao: AutenticacaoService,
    private utilService: UtilService,
    private adesao: AdesaoService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone // Adicionado para garantir atualização
  ) { }

  ngOnInit() {


    setTimeout(()=>{

      this.verificaCobrancaPaga();

    }, 2000)

  }



  FinalizarAdesao() {
    let cpf = this.autenticacao.getCredenciais().cpf;
    this.adesao.finalizarAdesao().pipe(
      finalize(() => { this.loading = false })
    )
      .subscribe(
        (res: any) => {
        },
      )
  }


  salvarAporteBoleto(): boolean {

    this.botaoDesabilitaPix = true;

    let valor = this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").value;
    let idcPrimerioAporte = this.parentForm.get("contribuicao.idcPrimerioAporte").value;

    if (valor < 50) {
      alert("O Valor mínimo do aporte é de R$: 50,00");
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue("");
      return false;
    }

    if (valor > 3000000) {
      alert("O Valor máximo do aporte é R$: 3.000.000,00");
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue("");
      return false;
    }

    this.loading = true;


    const dataAtual = new Date; // Data de hoje
    const dataMaisDoisDias = new Date(dataAtual.getTime() + 30 * 24 * 60 * 60 * 1000); //adicionando 30 dias

    this.adesao
      .salvaAporte(valor, dataMaisDoisDias.toISOString(), 1)
      .pipe(
        finalize(() => { this.loading = false })
      )
      .subscribe(
        (fileData) => {

          this.buscarDadosCobrancaBoleto()

        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )


    return false;
  }


  buscarDadosCobrancaBoleto() {

    this.adesao.BuscarCobranca()
      .pipe(
        finalize(() => { this.loading = false })
      )
      .subscribe(
        (res: any) => {

          this.idcobranca = res;
          if (this.idcobranca != null) {

            this.buscarDadosBoleto(this.idcobranca);
            if (this.dadosBoleto != null) {

            }

          }


        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )
  }

  buscarDadosBoleto(_idcobranca: number) {

    this.adesao.dadosBoleto(_idcobranca)
      .pipe(finalize(() => { this.loading = false }))
      .subscribe(
        (res: any) => {
          this.zone.run(() => {
            this.dadosBoleto = res;
            this.botaoDesabilitado = true;
            this.cdr.detectChanges();
          });
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )
  }

  gerarPDFBoleto() {

    this.loading = true;

    this.adesao
      .gerarBoleto(this.dadosBoleto.COD_COBRANCA)
      .pipe(
        finalize(() => { this.loading = false })
      )
      .subscribe(
        (fileData) => {

          let nomeBoleto = `boleto_vmp.pdf`;
          this.utilService.salvarArquivo(fileData, nomeBoleto)
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )

  }

  copyToClipboardAndToast(valueToCopy: string, msg: string) {
    navigator.clipboard.writeText(valueToCopy);
    this.toastr.success(msg);
  }

  salvarAportePix(): boolean {

    this.botaoDesabilitaBoleto = true;

    let valor = this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").value;
    let idcPrimerioAporte = this.parentForm.get("contribuicao.idcPrimerioAporte").value;

    if (valor < 50) {
      alert("O Valor mínimo do aporte é de R$: 50,00");
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue("");
      return false;
    }

    if (valor > 3000000) {
      alert("O Valor máximo do aporte é R$: 3.000.000,00");
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue("");
      return false;
    }

    this.loading = true;


    const dataAtual = new Date(); // Data de hoje
    const dataMaisDoisDias = new Date(dataAtual.getTime() + 3 * 24 * 60 * 60 * 1000);

    this.adesao
      .salvaAportePix(valor, dataMaisDoisDias.toISOString(), 1)
      .pipe(
        finalize(() => { this.loading = false })
      )
      .subscribe(
        (res: any) => {
           this.idcobranca = res;
           this.buscarDadosPix(this.idcobranca);
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )


    return false;
  }

  buscarDadosPix(_idcobranca: number) {

    this.adesao
      .consultarDadosPix(this.idcobranca)
      .pipe(finalize(() => { this.loading = false }))
      .subscribe(
        (res: any) => {
          this.zone.run(() => {
            this.dadosPix = res;
            this.botaoDesabilitado = true;
            this.cdr.detectChanges();
          });
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      )
  }

  verificaCobrancaPaga() {
    this.adesao
      .CobrancaPaga()
      .pipe(finalize(() => { this.loading = false }))
      .subscribe(
        (res: string) => {
          if (res == "ADESAO") {
            this.botaoDesabilitaPix = false;
            this.botaoDesabilitado = false; // DESABITA BOLETO
            this.ativarBotao.emit(false); // (BOTÃO FINALIZAR BLOQUEADO)
          } else if (res == "PAGO") {
            this.mostrarBotao = false;
            // Não chama modal, pois agora abre em nova aba
            this.ativarBotao.emit(true); // esconder os botões (BOTÃO FINALIZAR DESBLOQUEADO)
          } else if (res == "NAO_PAGO") {
            this.BuscarDadosCobranca();
            this.ativarBotao.emit(false); // ABRIR MODAL BOLETO OU PIX (BOTÃO FINALIZAR BLOQUEADO)
          } else if (res == "VENCIDO") {
            this.botaoDesabilitaPix = false;
            this.botaoDesabilitado = false; // DESABITA BOLETO
            this.ativarBotao.emit(false); // (BOTÃO FINALIZAR BLOQUEADO)
          }
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      );
  }

  BuscarDadosCobranca() {
    this.adesao
      .BuscarDadosCobranca()
      .pipe(finalize(() => { this.loading = false }))
      .subscribe(
        (res: any) => {
          this.forma_pagamento = res.COD_FORMA_PGTO;
          if (this.forma_pagamento == 'P') {
            this.idcobranca = res.COD_COBRANCA;
            this.buscarDadosPix(this.idcobranca);
          } else if (this.forma_pagamento == 'B') {
            this.idcobranca = res.COD_COBRANCA;
            this.buscarDadosBoleto(this.idcobranca);
          }
        },
        (error: HttpErrorResponse) => {
          this.toastr.error(error.error.ex);
        }
      );
  }

  // Método para reabilitar todos os botões em caso de problema
  reabilitarBotoes() {
    this.mostrarBotao = true;
    this.botaoDesabilitado = false;
    this.botaoDesabilitaPix = false;
    this.botaoDesabilitaBoleto = false;
    this.loading = false;
  }
}
